import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/OtpVerification.css";

const OtpVerification = () => {
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;

    const handleChange = (index, e) => {
        const value = e.target.value;
        if (/^\d$/.test(value) || value === "") {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (value !== "" && index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const verifyOTP = async({ email, otp }) => {
        console.log('Verifying OTP for:', email, otp); // ✅ Debug
    
        try {
            const res = await fetch('https://dev-44ekppmh6lkd6qjq.us.auth0.com/oauth/token', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    grant_type: 'http://auth0.com/oauth/grant-type/passwordless/otp',
                    client_id: 'SVlio4lrsOTpSBYwYT4xoWMHGiEgFUkN',
                    username: email,
                    otp,
                    realm: 'email',
                    scope: 'openid email'
                })
            });
    
            const data = await res.json();
            console.log('Auth0 Response:', data); // ✅ Debug
    
            if (res.ok) {
                console.log('✅ OTP verified, redirecting...');
                navigate(`/set-password?email=${encodeURIComponent(email)}`);
            } else {
                console.error('❌ OTP Verification failed:', data);
                alert('OTP Verification failed: ' + (data.error_description || 'Unknown error'));
            }
        } catch (err) {
            console.error('🔥 Request failed:', err);
            alert('Network error: ' + err.message);
        }
    };
    
      

    return (
        <div className="otp-verification-container">
            <div className="otp-left">
                <img src="/log-img.png" alt="Sign Up" className="signup-image" />
                <img src="/star-icon.svg" alt="Star Icon" className="star-icon star-icon-top" />
                <img src="/blue-star-icon.svg" alt="Star Icon" className="star-icon star-icon-bottom" />
                <div className="white-circle"></div>

                <div className="otp-badge track">
                    <img src="/track-icon.svg" alt="Track Icon" />
                    <p>Track & Manage <br />documents on the go!</p>
                </div>
                <div className="white-circle-bottom"></div>
                <div className="white-circle-bottom-right"></div> 
                <div className="white-circle-bottom-right-up"></div> 
                <div className="otp-badge speed">
                    <img src="/speed-icon.svg" alt="Speed Icon" />
                    <p>Gain speed with <br />your document delivery 🚀</p>
                </div>
                <div className="otp-badge dispatch">
                    <img src="/dispatch-icon.svg" alt="Dispatch Icon" />
                    <p>Dispatch your Cheques <br />from anywhere</p>
                </div>
            </div>

            <div className="otp-right">
                <div className="otp-card-wrapper">
                    <div className="otp-card">
                        <h2 className="otp-title">Confirm your email address 📧</h2>
                        <p className="otp-subtext">
                            Enter the 6-digit code sent to <br />
                            <strong>{email}</strong>
                        </p>

                        <img src="/verification.svg" alt="Verification" className="verification-image" />

                        <div className="otp-inputs">
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleChange(index, e)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    className={`otp-box ${digit ? "filled" : ""}`}
                                />
                            ))}
                        </div>

                        <p className="otp-resend">
                            Didn't receive the code? <span className="resend-link">Resend Code</span>
                        </p>

                        <button className="otp-button" onClick={() => verifyOTP({ email, otp: otp.join("") })}>Verify</button>


                        <p className="otp-terms">
                            By signing up, you agree to our <span className="terms-link">Terms and Conditions</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtpVerification;
